import { Controller } from "@hotwired/stimulus"

// Kapazitätsplanung › Auslastung. Every period's detail panel is rendered on the page; clicking a
// chart column shows that period's panel and marks the column and its heatmap header (styled
// through data-selected). Also opens / closes the native "Ziel einstellen" dialog.
export default class extends Controller {
  static targets = ["column", "detail", "heatHeader", "dialog"]
  static values = { selected: Number }

  select(event) {
    this.selectedValue = Number(event.currentTarget.dataset.index)
  }

  selectedValueChanged() {
    const selected = String(this.selectedValue)
    this.columnTargets.forEach((column) => {
      const active = column.dataset.index === selected
      column.dataset.selected = active
      column.setAttribute("aria-pressed", active)
    })
    this.heatHeaderTargets.forEach((header) => {
      header.dataset.selected = header.dataset.index === selected
    })
    this.detailTargets.forEach((detail) => {
      detail.classList.toggle("hidden", detail.dataset.index !== selected)
    })
  }

  openDialog() {
    if (this.hasDialogTarget) this.dialogTarget.showModal()
  }

  closeDialog() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }
}
